import React from 'react';
export const WatchSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_583_290)">
        <path
          d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 3.5C9.87827 3.5 7.50029 4.49971 6 6C4.49971 7.50029 3.5 9.87827 3.5 12C3.5 14.1217 4.49971 16.4997 6 18C7.50029 19.5003 9.87827 20.5 12 20.5C14.1217 20.5 16.4997 19.5003 18 18C19.5003 16.4997 20.5 14.1217 20.5 12C20.5 9.87827 19.5003 7.50029 18 6C16.4997 4.49971 14.1217 3.5 12 3.5ZM12 6C12.2449 6.00003 12.4813 6.08996 12.6644 6.25272C12.8474 6.41547 12.9643 6.63975 12.993 6.883L13 7V11.586L15.707 14.293C15.8863 14.473 15.9905 14.7144 15.9982 14.9684C16.006 15.2223 15.9168 15.4697 15.7488 15.6603C15.5807 15.8508 15.3464 15.9703 15.0935 15.9944C14.8406 16.0185 14.588 15.9454 14.387 15.79L14.293 15.707L11.293 12.707C11.1376 12.5514 11.0378 12.349 11.009 12.131L11 12V7C11 6.73478 11.1054 6.48043 11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6Z"
          fill="#535761"
        />
      </g>
      <defs>
        <clipPath id="clip0_583_290">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
